import { Dispatch } from 'redux';
import { Airport } from '../../models/Flight/Airport';

export const ADD_FLIGHT = 'FLIGHTS_ADD_FLIGHT';
export const REMOVE_FLIGHT = 'FLIGHTS_REMOVE_FLIGHT';
export const SET_DATE = 'FLIGHTS_SET_DATE';
export const SET_ORIGIN = 'FLIGHTS_SET_ORIGIN';
export const SET_DESTINATION = 'FLIGHTS_SET_DESTINATION';

export const addFlightAction = () => (dispatch: Dispatch<any>) => {
    dispatch({
        type: ADD_FLIGHT
    });
};

export const removeFlightAction = (index?: number) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: REMOVE_FLIGHT,
        index
    });
};

export const setDateFlightAction = (date: string, index: number) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_DATE,
        date,
        index
    });
};

export const setOriginFlightAction = (airport: Airport, index: number) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_ORIGIN,
        airport,
        index
    });
};

export const setDestinationFlightAction = (airport: Airport, index: number) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_DESTINATION,
        airport,
        index
    });
};



// WEBPACK FOOTER //
// ./src/actions/Flight/searchParams.ts